<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import TableExpand from "../rds/TableExpand.vue";
let self = {};
export default {
  name: "TableRelationalDatabaseServiceResourceHwc",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      columns: [
        // {
        //   type: "expand",
        //   width: 50,
        //   render: (h, params) => {
        //     return h(TableExpand, {
        //       props: {
        //         row: params.row,
        //       },
        //     });
        //   },
        // },
        {
          title: this.$t("RAM.HWC.RDS.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.HWC.RDS.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.HWC.RDS.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.HWC.RDS.instanceName"),
          key: "name",
        },
        {
          title: this.$t("RAM.HWC.RDS.instanceID"),
          key: "databaseId",
        },
        {
          title: this.$t("RAM.HWC.RDS.engineVersion"),
          key: "version",
        },
        {
          title: this.$t("RAM.HWC.RDS.state"),
          key: "stateName",
        },
        {
          title: this.$t("RAM.HWC.RDS.instanceType"),
          key: "type",
        },
      ],
      tableData: [],
    };
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", (val) => {
      this.companyId = val;
    });
    eventBus.$on("accountName", (val) => {
      this.accountName = val;
    });
    eventBus.$on("instanceId", (val) => {
      this.instanceId = val;
    });
    eventBus.$on("accountSearchKey", (val) => {
      this.accountSearchKey = val;
    });
    self = this;
  },
  methods: {
    showAll() {
      self.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData() {
      this.$api.resourceManagement
        .selectHWCCloudDatabaseByPage({
          companyId: self.companyId,
          accountName: self.accountName,
          databaseId: self.instanceId,
          accountIds: self.accountSearchKey,
          pageNum: self.current,
          pageSize: self.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage(current) {
      this.current = current;
      this.getData();
    },
    changeSize(pageSize) {
      this.pageSize = pageSize;
      this.getData();
    },
    // 销毁
    beforeDestroy() {
      eventBus.$off("companyId");
      eventBus.$off("accountName");
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/hwc/rds/TableRelationalDatabaseServiceResourceHwc.vue